<template>
    <FloatingMenu :editor="editor" :options="{placement: 'left', offset: 25}">
        <VJoyDropdown width="220" close-on-select class="editor__dropdown" :direction="dropdownDirection">
            <template #dropdown-button>
                <VJoyIconButton class="editor__dropdown__button" icon="add" size="xxsmall" />
            </template>
            <template #dropdown-items>
                <VJoyMenuItem
                    v-for="item in PORTFOLIO_EDITOR_ITEMS"
                    :key="item.event"
                    :label="item.label"
                    :icon="item.icon"
                    type="button"
                    @click="(emit as any)(item.event)"
                />
            </template>
        </VJoyDropdown>
    </FloatingMenu>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import type {Editor} from '@tiptap/vue-3';
    import {FloatingMenu} from '@tiptap/vue-3/menus';
    import {VJoyIconButton, VJoyDropdown, VJoyMenuItem} from '@maltjoy/core-vue';
    import type {PortfolioEditorMenuEmits} from '~/features/portfolio/editor/composable/portfolioEditorEmits';
    import {PORTFOLIO_EDITOR_ITEMS} from '~/features/portfolio/editor/composable/portfolioEditorItems';

    const props = defineProps<{editor: Editor}>();

    const dropdownDirection = computed(() => {
        const {from} = props.editor.state.selection;
        const coords = props.editor.view.coordsAtPos(from);
        return window.innerHeight - coords.bottom < 260 ? 'up' : 'down';
    });

    const emit = defineEmits<PortfolioEditorMenuEmits>();
</script>

<style lang="scss" scoped>
    .editor__dropdown {
        &__button {
            background-color: var(--joy-color-secondary-10);

            &:hover {
                background-color: var(--joy-color-secondary-10);
            }

            :deep(.joy-icon) {
                color: var(--joy-color-secondary-50);
            }
        }
    }

    :deep(.joy-dropdown-list__items-slotted) {
        padding: 0 !important;
    }
</style>
